// extracted by mini-css-extract-plugin
export default {"container":"History_container__X8plz","history":"History_history__CofL1","text":"History_text__4wQLX","date":"History_date__sD2jm"};